import { makeLogger } from '../../../../../logger/logger';
import { authenticationHeaders, type authenticationHeadersInterface } from '../../../../guided/subcomponents/utils';
import { getUIDSessionStorageValue, setUIDSessionStorageValue } from '../storage-manager/storage-manager-helpers';
import { answerViewTypes } from '../utils/utils';

const { err } = makeLogger({
  pathToCurrentFile: 'components/widgets/conversational-search/conversational-search-logic/conversational-search-connector/conversational-search-connector.ts',
  loggersList: ['err'],
});

const errorObject = {
  type: answerViewTypes.ErrorMessage,
  isErrorResponse: true,
};

const handleError = (message: string, error?: string) => {
    err(message, error);
    return errorObject;
};

const fetchWithAuth = async (
  url: string,
  method: string,
  authHeaders: authenticationHeadersInterface,
  body: Object
) => {
    try {
      const response = await fetch(url, {
        method,
        headers: { 'content-type': 'application/json', ...authHeaders },
        body: JSON.stringify(body)
      });

      if (!response.ok || response.status < 200 || response.status >= 300) throw new Error('Wrong network response status');

      return await response.json();
    } catch (error) {
      return handleError('Request failed', error);
    }
};

const getAuthHeaders = async (tokenUrl: string, auth: string) => {
    try {
      return await authenticationHeaders({
        tokenUrl,
        apigeeBasicAuth: auth,
      });
    } catch (error) {
      err('Authentication failed', error);
      return false;
    }
};

const createConversation = async (endpoint: string, authHeaders: authenticationHeadersInterface) => {
    const url = `${endpoint}/conversations`;
    const result = await fetchWithAuth(url, 'POST', authHeaders, {});

    if (result?.conversationId) setUIDSessionStorageValue(result.conversationId);

    return result;
};

export const conversationalSearchConnector = async (
  tokenUrl: string,
  auth: string,
  endpoint: string,
  userQuery: string,
  language: string,
  country: string
) => {
    const authHeaders = await getAuthHeaders(tokenUrl, auth);
    if (!authHeaders) return handleError('Request failed');

    let userId = getUIDSessionStorageValue();
    if (!userId) {
      const newConversation = await createConversation(endpoint, authHeaders);
      if (newConversation.isErrorResponse) return handleError('New conversation request failed');
      userId = newConversation.conversationId;
    }

    const requestBody = {
      type: 'conversation/request',
      query: userQuery?.toString(),
      context: { type: 'conversation/context/locale', country, language },
      converserName: 'genai/find',
      persisted: false,
    };

    return await fetchWithAuth(`${endpoint}/conversations/${userId}`, 'POST', authHeaders, requestBody);
};